import { BiStreetView } from "react-icons/bi";

export async function Recuperer_adresse_avec_coord(coordinates) {
    const { lat, lng } = coordinates;
  
    
    if (typeof lat !== "number" || typeof lng !== "number") {
      throw new Error("Les coordonnées doivent contenir des valeurs numériques pour lat et lng.");
    }
    const apiUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`Erreur HTTP : ${response.status}`);
      }
      const data = await response.json();
      if (!data.address) {
        throw new Error("Impossible de trouver une adresse pour ces coordonnées.");
      }
      const address = data.display_name || `${data.address.road || ""}, ${data.address.city || ""}, ${data.address.country || ""}`;
      
      return address;
    } catch (error) {
      console.error("Erreur lors de la récupération de l'adresse :", error);
      return "Adresse introuvable.";
    }
  }




export const Recuperer_coord_avec_adresse = (address, setGeocodeResults) => {
  const geocodeUrl = `https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(address)}`;
  
  
  fetch(geocodeUrl)
      .then(response => response.json())
      .then(data => {
          if (data.features && data.features.length > 0) {
            console.log("features:", data.features);
              const results = data.features.map(feature => ({
                
                  label: (feature.properties.label.split(" ").includes(feature.properties.postcode) 
                      ? feature.properties.label 
                      : feature.properties.label + " " + feature.properties.postcode),
                  coordinates: feature.geometry.coordinates,
                  city: feature.properties.city,
                  postcode: feature.properties.postcode,
                  houseNumber: feature.properties.housenumber,
                  street: feature.properties.street,
              }));
              setGeocodeResults(results);
          } else {
              setGeocodeResults([]);
          }
      })
      .catch(err => console.error('Erreur lors du géocodage:', err));
};





//Quand l'utilsateur clique sur "Ma Position", cette fonction adapte les coordonnées à celle de l'utilisateur
export const handleUserCurrentLocation = (setUseFitBounds, setCoordinates) => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setUseFitBounds(false);
                setCoordinates({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                });
                setTimeout(() => {
                    setUseFitBounds(true);
                }, 2500);
            },
            (error) => {
                alert("Impossible d'obtenir votre position");
                console.error("Geolocation error: ", error);
            }
        );
    } else {
        alert("La géolocalisation n'est pas supportée par ce navigateur.");
    }
};


